import { useCallback } from 'react';
import { useToast } from './use-toast';
import { AlertCircle, CheckCircle, Info, AlertTriangle } from 'lucide-react';

type FeedbackType = 'success' | 'error' | 'info' | 'warning';

type ToastVariant = 'default' | 'destructive' | 'success' | 'warning' | 'info';

// Configuración para los diferentes tipos de toast
const toastConfig = {
  success: {
    icon: CheckCircle,
    title: 'Éxito',
    variant: 'success' as ToastVariant,
    duration: 3000
  },
  error: {
    icon: AlertCircle,
    title: 'Error',
    variant: 'destructive' as ToastVariant,
    // Un error hay que poder leerlo entero (y entender qué hacer): 5 s se
    // quedaba corto para los mensajes de dos líneas. Radix pausa el temporizador
    // mientras el puntero o el foco están sobre el aviso.
    duration: 7000
  },
  info: {
    icon: Info,
    title: 'Información',
    variant: 'info' as ToastVariant,
    duration: 5000
  },
  warning: {
    icon: AlertTriangle,
    title: 'Advertencia',
    variant: 'warning' as ToastVariant,
    duration: 6000
  }
};

export function useFeedbackToast() {
  const { toast } = useToast();

  const showFeedback = useCallback((type: FeedbackType, message: string, customDuration?: number) => {
    const config = toastConfig[type];
    const Icon = config.icon;
    
    toast({
      variant: config.variant,
      title: config.title,
      description: message,
      duration: customDuration || config.duration,
      icon: <Icon className="h-5 w-5" />
    });
  }, [toast]);

  return {
    showFeedback
  };
}